export default "__VITE_ASSET__Bwi9p5Ph__"